import { render, staticRenderFns } from "./editClaimedBenefit.vue?vue&type=template&id=60c6bc3f&"
import script from "./editClaimedBenefit.vue?vue&type=script&lang=js&"
export * from "./editClaimedBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports